import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { FeedbackHeader } from 'app/constants/table-header-constants';
import useFeedbackManagement from './useFeedbackManagement';

const FeedbackManagement = () => {
  const {
    fetchFeedbackData,
    handleDelete,
    handleEdit,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    totalNumber,
    navigate,
    filteredData,
    sectionObj,
  } = useFeedbackManagement();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={FeedbackHeader}
          data={filteredData}
          fulldata={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          pageLoading={pageLoading}
          navigate={navigate}
          fetchData={fetchFeedbackData}
        />
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default FeedbackManagement;
